import { UseFormReturn } from 'react-hook-form'

import { CustomFormQuestion } from 'components/tools/CustomForm/types'
import setRecessoBolsista from './utils/setRecessoBolsista'
import setAdmissãoPadraoAGSUSPrazoDeterminado from './utils/setAdmissãoPadraoAGSUSPrazoDeterminado'
import setAtualizacaoDeDadosCadastraisSEDE from './utils/setAtualizacaoDeDadosCadastraisSEDE'
import setAtualizacoesDosDadosCadastraisMedicos from './utils/setAtualizacoesDosDadosCadastraisMedicos'
import setAtualizacaoDeDadosCadastraisSaudeIndigena from './utils/setAtualizacaoDeDadosCadastraisSaudeIndigena'
import setCalculoDeDiariasDoAGSUS from './utils/setCalculoDeDiariasDoAGSUS'
import setDependentesDoAGSUS from './utils/setDependentesDoAGSUS'
import setCATComunicacaoDeAcidenteDeTrabalho from './utils/setCATComunicacaoDeAcidenteDeTrabalho'
import setCompensacaodeHoras from './utils/setCompensacaodeHoras'
import setEnvioDeAtestadoMedico from './utils/setEnvioDeAtestadoMedico'
import setLicencaMaternidade from './utils/setLicencaMaternidade'
import setLicencaPaternidade from './utils/setLicencaPaternidade'
import setLicencaAcompanhamentoDeFamiliarDoente from './utils/setLicencaAcompanhamentoDeFamiliarDoente'
import setSolicitacaoDeFerias from './utils/setSolicitacaoDeFerias'
import setLicencaMaternidadeSaudeIndigena from './utils/setLicencaMaternidadeSaudeIndigena'
import setSolicitacaoDeFeriasAGSUS from './utils/setSolicitacaoDeFeriasAGSUS'
import setSolicitacaoDeFeriasAGSUS_Rejeicao from './utils/setSolicitacaoDeFeriasAGSUS_Rejeicao'
import setLicencaAcompanhamentoDeFamiliarDoenteEscritorioESaudeIndigena from './utils/setLicencaAcompanhamentoDeFamiliarDoenteEscritorioESaudeIndigena'
import setEnvioDeAtestadoMedicoSaudeIndigena from './utils/setEnvioDeAtestadoMedicoSaudeIndigena'
import setLicencaPaternidadeMedicosCLT from './utils/setLicencaPaternidadeMedicosCLT'
import setLicencaPaternidadeSaudeIndigenaEEscritoriosRegionais from './utils/setLicencaPaternidadeSaudeIndigenaEEscritoriosRegionais'
import setLicencaPaternidadeMedicoBolsista from './utils/setLicencaPaternidadeMedicoBolsista'
import setRegistroDeHoraExtra from './utils/setRegistroDeHoraExtra'
import setCancelamentoAlteracaoDeFerias from './utils/setCancelamentoAlteracaoDeFerias'
import setLevantamentoDeStatusVacinal from './utils/setLevantamentoDeStatusVacinal'
import setSolicitacaoDeGratificacaoPorTitulacaoEspecializacao from './utils/setSolicitacaoDeGratificacaoPorTitulacaoEspecializacao'
import setPreContratacaoDSEIeCASAI from './utils/setPreContratacaoDSEIeCASAI'

type GetFunctionByKeyString = {
  [key: string]: (params: { formMethods: UseFormReturn<any>; questions: CustomFormQuestion[] }) => CustomFormQuestion[]
}

type Params = {
  formId?: string
  formMethods: UseFormReturn<any>
  questions: CustomFormQuestion[]
}

export default function setGambiarra({ formMethods, questions, formId }: Params) {
  const getGambiarraFunctionByFormId = () => {
    const possibleQuestions: GetFunctionByKeyString = {
      '1000000047': setEnvioDeAtestadoMedico,
      '1000000048': setLicencaMaternidade,
      '1000000049': setLicencaPaternidade,
      '1000000052': setLicencaAcompanhamentoDeFamiliarDoente,
      '1000000054': setSolicitacaoDeFerias,
      '1000000060': setRecessoBolsista,
      '1000000065': setLicencaMaternidadeSaudeIndigena,
      '1000000077': setSolicitacaoDeFeriasAGSUS,
      '1000000078': setSolicitacaoDeFeriasAGSUS_Rejeicao,
      '1000000105': setLicencaAcompanhamentoDeFamiliarDoenteEscritorioESaudeIndigena,
      '1000000139': setEnvioDeAtestadoMedicoSaudeIndigena,
      '1000000142': setLicencaPaternidadeMedicosCLT,
      '1000000145': setLicencaPaternidadeSaudeIndigenaEEscritoriosRegionais,
      '1000000148': setLicencaPaternidadeMedicoBolsista,
      '1000000154': setPreContratacaoDSEIeCASAI,
      '1000000221': setCompensacaodeHoras,
      '1000000231': setRegistroDeHoraExtra,
      '1000000238': setCancelamentoAlteracaoDeFerias,
      '1000000249': setAtualizacaoDeDadosCadastraisSEDE,
      '1000000251': setAtualizacoesDosDadosCadastraisMedicos,
      '1000000253': setAtualizacaoDeDadosCadastraisSaudeIndigena,
      '1000000260': setLevantamentoDeStatusVacinal,
      '1000000307': setCATComunicacaoDeAcidenteDeTrabalho,
    }

    const Function = possibleQuestions[formId as string]

    if (Function) return Function

    if (
      formId == '1000000046' /* Admissão Administrativo AgSUS - PRAZO DETERMINADO */ ||
      formId == '1000000136' /* Admissão saude indigena - PRAZO DETERMINADO */ ||
      formId == '1000000154' /* Pré-Contratação DSEI e CASAI */ ||
      formId == '1000000228' /* Admissão saúde indígena - EXPERIÊNCIA */ ||
      formId == '1000000225' /* Admissão Administrativo AgSUS - PRAZO INDETERMINADO */ ||
      formId == '1000000294' /* Admissão Administrativo AgSUS - CARGO DE CONFIANÇA */ ||
      formId == '1000000298' /* Admissão Médicos de Família e Comunidade */ ||
      formId == '1000000302' /* Admissão Projetos - PRAZO INDETERMINADO */ ||
      formId == '1000000315' /* Admissão saude indigena - PRAZO DETERMINADO */ ||
      formId ==
        '1000000331' /* Admissão Bolsistas - Projeto de ensino, pesquisa, extensão, tecnologia e inovação da AgSUS */ ||
      formId == '1000000361' /* Admissão Administrativo AgSUS - Jovem Aprendiz */ ||
      formId == '1000000342' /* Admissão Bolsistas - Projeto Plataforma de Apoio à Gestão do Trabalho para o SUS */ ||
      formId ==
        '1000000346' /* Admissão Bolsistas - Projeto FormAgSUS – Rede Colaborativa de Ensino e Pesquisa da AgSUS */ ||
      formId == '1000000350' /* Admissão Bolsistas - Projeto FormAgSUS – Painel de Especialistas */ ||
      formId == '1000000354' /*Admissão Bolsistas - Projeto FormAgSUS – DataSUS */
    ) {
      return setAdmissãoPadraoAGSUSPrazoDeterminado
    }

    if (formId == '1000000337' || formId == '1000000339') {
      return setSolicitacaoDeGratificacaoPorTitulacaoEspecializacao
    }

    const foundDaily = questions.find(
      (element) => element.title == 'Trecho 1- Destino é capital ou demais localidades?'
    )

    if (foundDaily) return setCalculoDeDiariasDoAGSUS

    const foundDependents = questions.find((element) => element.title == 'Dependente 1 - Nome completo')

    if (foundDependents) return setDependentesDoAGSUS
  }

  async function getQuestionsByGambiarra() {
    const execFunction = getGambiarraFunctionByFormId()
    if (!execFunction) return questions
    const formatedQuestions = execFunction({ questions, formMethods })
    return formatedQuestions
  }

  return { getQuestionsByGambiarra }
}
